export type KintoneApiResponseError = {
  errorCode: keyof typeof KintoneApiResponseErrorCodes;
  operation: keyof typeof KintoneApiResponseErrorOperationTypes | "UNKNOWN";
};

export const KintoneApiResponseErrorCodes = {
  API_TOKEN: "kintone_api_response_error.api_token",
  CONTENT: "kintone_api_response_error.content",
  UNKNOWN: "kintone_api_response_error.unknown",
} as const;

export const KintoneApiResponseErrorOperationTypes = {
  GET_APP: "GetApp",
  GET_FIELDS: "GetFields",

  UPLOAD_FILE: "UploadFile", // GUI では発生しないはず
  ADD_RECORDS: "AddRecords", // GUI では発生しないはず
} as const;

// parse に成功した場合はフォーマットされたエラーを返却する。
// 失敗した場合（オブジェクトの形が異なる、エラーのコードが異なる等）は undefined を返却する。
export const parseError = (
  error: unknown,
): KintoneApiResponseError | undefined => {
  if (
    typeof error === "object" &&
    !!error &&
    "message" in error &&
    typeof error.message === "string" &&
    "extensions" in error &&
    typeof error.extensions === "object" &&
    !!error.extensions &&
    "code" in error.extensions &&
    typeof error.extensions.code === "string"
  ) {
    const {
      message,
      extensions: { code },
    } = error;

    const errorCode = Object.entries(KintoneApiResponseErrorCodes).find(
      ([, value]) => value === code,
    )?.[0];
    if (!errorCode) {
      return undefined;
    }
    const operation =
      Object.entries(KintoneApiResponseErrorOperationTypes).find(([, value]) =>
        message.startsWith(value),
      )?.[0] ?? "UNKNOWN";

    // Object.entries が key の型を string にしてしまうので、型を戻す
    return {
      errorCode: errorCode as KintoneApiResponseError["errorCode"],
      operation: operation as KintoneApiResponseError["operation"],
    };
  }

  return undefined;
};

export const KintoneExportSettingCreateErrorCodes = {
  NO_EMAIL_USER_IN_GROUP:
    "bad_request.kintone_export_setting_no_email_user_in_group",
} as const;

export type KintoneExportSettingCreateError = {
  errorCode: keyof typeof KintoneExportSettingCreateErrorCodes;
};

export const parseKintoneExportSettingCreateError = (
  error: unknown,
): KintoneExportSettingCreateError | undefined => {
  if (
    typeof error === "object" &&
    !!error &&
    "extensions" in error &&
    typeof error.extensions === "object" &&
    !!error.extensions &&
    "code" in error.extensions &&
    typeof error.extensions.code === "string"
  ) {
    const {
      extensions: { code },
    } = error;

    const exportSettingCreateErrorCode = Object.entries(
      KintoneExportSettingCreateErrorCodes,
    ).find(([, value]) => value === code)?.[0];

    if (!exportSettingCreateErrorCode) {
      return undefined;
    }

    // Object.entries が key の型を string にしてしまうので、型を戻す
    return {
      errorCode:
        exportSettingCreateErrorCode as KintoneExportSettingCreateError["errorCode"],
    };
  }

  return undefined;
};
